(function () {
  if (!window.DiyonaPrivacy) return;
  window.DiyonaPrivacy.whenAllowed("advertising", function () {
  "use strict";
  /* Diyona first-party attribution -> cart/order note attributes.
     Ported from Stienhardt spx-sth-attribution.js; adds _ad_id (Diyona
     utm_content carries the numeric Meta ad id) and post-ATC flushing.
     v2: Meta click ids (_fbp/_fbc) in cart attributes + once-per-visitor
     micro events (second_item_added / high_value_cart / email_signup)
     mirrored to fbq and the collector with a shared event id for dedup.
     v3: diamond_added micro event -- a /cart/add carrying a `Diamond`
     line-item property is a diamond selection (the deepest builder step),
     tracked distinctly from a generic add_to_cart.
     v4: setting_selected (rb_setting cookie set by "Choose This Setting") and
     initiate_checkout (storefront name="checkout" click) complete the builder
     funnel: landing -> setting -> diamond -> checkout -> purchase.
     v5: (a) diamond_selected (rb_diamond cookie set by "Select This Diamond")
     fills the missing middle rung -- the old diamond_added fired on the CART ADD,
     two steps later, so setting->diamond read as a collapse that was not real;
     (b) diamond_added renamed diamond_in_cart / FPDiamondInCart to stop it being
     read as a diamond PICK; (c) the browser fbq() leg is gone -- every event now
     reaches Meta once, server-side via the collector. Meta was counting the fbq
     and CAPI legs separately, so every FP total read ~2x the real number.
     Funnel: landing -> setting_selected -> diamond_selected -> diamond_in_cart
             -> initiate_checkout -> purchase.
     v6: Meta in-app browser handoff. The IG/FB webview keeps its own cookie
     jar, so "Open in external browser" used to arrive as a blank visitor.
     Inside a Meta in-app browser we now mirror the attribution into the URL
     itself (?dyad=<ad>~<campaign>~<ts>~<fbclid>) on every page load via
     history.replaceState, and re-append it through other scripts' own
     pushState/replaceState rewrites (the diamond search rewrites the URL as
     filters change). The webview hands over ONLY the current URL, so the
     token rides across the jar boundary. Any browser landing on a dyad URL
     restores first/last touch, _fbc (with the ORIGINAL click timestamp) and
     the custom pixel's diy_ad gate, then strips the param from the address
     bar. URL edits are plain string appends/removals -- the rest of the
     query string is never re-encoded. Organic in-app sessions (no ad id, no
     click id) get no token. Guardrails: the token is minted only while the
     click evidence is <= 7 days old and consumed only while <= 48h old (a
     real handoff is seconds old; this caps shared-link contamination), a
     token-sourced fbclid never OVERWRITES an existing _fbc, and the landing
     URL stored in first-touch is token-stripped. The diamond-search page
     rewrites the URL during HTML parse (before any deferred script runs),
     so landing params are recovered from the performance navigation entry
     when the live search lacks them -- this also repairs plain utm/fbclid
     ad landings on that page, which v5 was silently losing.
     v7: initiate_checkout listens on window (capture), not document, so the
     cart page's own checkout interceptor (optimistic-cart.js) cannot swallow
     the click before this script sees it. */
  var FT = "_diy_ft", LT = "_diy_lt", VID = "_diy_vid";
  var FT_DAYS = 180, VID_DAYS = 730, FBC_DAYS = 90;
  var FLAGS = "diy_fp_flags";
  var COLLECT = "https://diyona-ad-dashboard.vercel.app/api/collect";

  function consentOK() { return !!window.DiyonaPrivacy && window.DiyonaPrivacy.allowed("advertising"); }
  function consentState() { return consentOK() ? "granted" : "denied"; }
  function getCookie(n) {
    var m = document.cookie.match("(?:^|; )" + n + "=([^;]*)");
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(n, v, days, domain) {
    if (!consentOK()) return ;
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = n + "=" + encodeURIComponent(v) + ";expires=" + d.toUTCString() + ";path=/" + (domain ? ";domain=" + domain : "") + ";SameSite=Lax;Secure";
  }
  function uuid() {
    return (window.crypto && crypto.randomUUID) ? crypto.randomUUID() :
      "xxxxxxxxyxxxxxxx".replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0;
        return (c === "x" ? r : (r & 3 | 8)).toString(16);
      });
  }
  function adId(content) {
    return /^[0-9]{6,25}$/.test(content || "") ? content : "";
  }

  if (!consentOK()) return;

  var qs = new URLSearchParams(location.search);

  /* v6: the diamond-search section rewrites the URL synchronously during
     HTML parse (its inline IIFE calls replaceState before deferred scripts
     run), wiping utm_* / fbclid / dyad from location.search before we ever
     see them. The performance navigation entry keeps the ORIGINAL request
     URL, so fall back to it whenever the live search carries no signal. */
  try {
    if (!qs.get("utm_source") && !qs.get("utm_content") && !qs.get("fbclid") && !qs.get("dyad")) {
      var navEnt = (performance.getEntriesByType && performance.getEntriesByType("navigation")) || [];
      var origUrl = (navEnt[0] && navEnt[0].name) || "";
      var qPos = origUrl.indexOf("?");
      if (qPos !== -1) {
        var origSearch = origUrl.slice(qPos);
        var hPos = origSearch.indexOf("#");
        if (hPos !== -1) origSearch = origSearch.slice(0, hPos);
        var q2 = new URLSearchParams(origSearch);
        if (q2.get("utm_source") || q2.get("utm_content") || q2.get("fbclid") || q2.get("dyad")) qs = q2;
      }
    }
  } catch (e) {}

  /* v6: Meta in-app browser detection + handoff-token parse. Token format:
     dyad=<ad_id>~<campaign_id>~<ts_ms>~<fbclid>, every part optional but
     strictly validated (numeric ids, ms-era timestamp, fbclid charset) so a
     mangled or hostile param can never reach a cookie. Tokens older than
     48h (or with no timestamp) are ignored entirely: a genuine handoff is
     seconds old, so the cutoff only rejects stale shared/bookmarked links. */
  var IAB = /Instagram|FBAN|FBAV|FB_IAB|FBIOS|Barcelona/.test(navigator.userAgent || "");
  var DYAD_MAX_AGE = 48 * 3600 * 1000;
  var tok = null;
  (function () {
    var raw = qs.get("dyad");
    if (!raw) return;
    var p = raw.split("~");
    var t = {
      ad: adId(p[0]),
      camp: adId(p[1]),
      ts: /^[0-9]{12,14}$/.test(p[2] || "") ? +p[2] : 0,
      fbclid: /^[A-Za-z0-9_.-]{8,500}$/.test(p[3] || "") ? p[3] : ""
    };
    if (!t.ts) return;
    var age = Date.now() - t.ts;
    if (age > DYAD_MAX_AGE || age < -36e5) return;
    if (t.ad || t.fbclid) tok = t;
  })();

  var touch = {
    source: qs.get("utm_source") || "",
    medium: qs.get("utm_medium") || "",
    campaign: qs.get("utm_campaign") || "",
    content: qs.get("utm_content") || "",
    ts: new Date().toISOString(),
    referrer: document.referrer || "",
    landing: location.pathname + stripDyad(location.search)
  };

  /* v6: a restored token stands in for the UTMs the handoff lost. Real UTMs
     in the URL always win; the token only fills blanks, and the original
     click time is kept when this browser has no first touch yet. */
  if (tok && !touch.content && tok.ad) {
    touch.content = tok.ad;
    if (!touch.source) touch.source = "meta";
    if (!touch.medium) touch.medium = "paid_social";
    if (!touch.campaign && tok.camp) touch.campaign = tok.camp;
    if (tok.ts && !getCookie(FT)) touch.ts = new Date(tok.ts).toISOString();
  }

  var vid = getCookie(VID);
  if (!vid) { vid = uuid(); setCookie(VID, vid, VID_DAYS); }

  var hasSource = !!touch.source || (touch.referrer && touch.referrer.indexOf(location.host) === -1);
  if (!getCookie(FT) && hasSource) setCookie(FT, JSON.stringify(touch), FT_DAYS);
  if (hasSource) setCookie(LT, JSON.stringify(touch), FT_DAYS);

  /* The pixel may be blocked, so persist _fbc ourselves from fbclid.
     Domain-scoped to eTLD+1 so we share the Meta pixel's cookie slot instead
     of shadowing it with a host-only twin, and refreshed whenever a NEW
     fbclid arrives (not only when absent). */
  var COOKIE_DOMAIN = /(^|\.)diyona\.com$/.test(location.hostname) ? ".diyona.com" : "";
  var urlFbclid = qs.get("fbclid") || "";
  var fbclid = urlFbclid || (tok && tok.fbclid) || "";
  if (fbclid) {
    var curFbc = getCookie("_fbc");
    /* A live fbclid param refreshes _fbc on any NEW click (v5 behavior). A
       token-sourced fbclid only fills an ABSENT _fbc -- it must never
       replace a click id this browser earned itself -- and keeps the
       ORIGINAL click timestamp (per Meta's fbc spec: creationTime is when
       the fbclid was first observed). */
    if (urlFbclid) {
      if (!curFbc || curFbc.indexOf(fbclid) === -1)
        setCookie("_fbc", "fb.1." + Date.now() + "." + fbclid, FBC_DAYS, COOKIE_DOMAIN);
    } else if (!curFbc) {
      setCookie("_fbc", "fb.1." + tok.ts + "." + fbclid, FBC_DAYS, COOKIE_DOMAIN);
    }
  }

  /* v6: best-effort bridge for the Shopify custom pixel, which gates every
     event on a diy_ad localStorage key it normally captures from utm_content
     on landing. A handoff arrival has no utm_content, so hand it the ad id.
     Plain string, set only when absent (first-touch semantics). */
  if (tok && tok.ad) {
    try { if (!localStorage.getItem("diy_ad")) localStorage.setItem("diy_ad", tok.ad); } catch (e) {}
  }

  /* v6: keep the token in the address bar inside the Meta in-app browser;
     strip a consumed token everywhere else. String surgery only -- never
     rebuild the query string, other params pass through byte-identical. */
  function fbcParts() {
    var m = /^fb\.[0-9]\.([0-9]{12,14})\.([A-Za-z0-9_.-]+)$/.exec(getCookie("_fbc") || "");
    return m ? { ts: +m[1], fbclid: m[2] } : null;
  }
  /* The token stands in for the click behind THIS session, so it is minted
     last-touch-first, with campaign taken from the SAME touch as the ad id.
     Falls back to the live page params (touch/urlFbclid) so a cookie-blocked
     webview can still mint on the ad landing itself. Click evidence older
     than 7 days (Meta's click-attribution window) mints nothing -- an
     organic in-app visit months after an old ad click must not decorate
     URLs with that stale identity. */
  function dyadToken() {
    if (!consentOK()) return "";
    var ft = null, lt = null;
    try { ft = JSON.parse(getCookie(FT) || "null"); } catch (e) {}
    try { lt = JSON.parse(getCookie(LT) || "null"); } catch (e) {}
    var src = (lt && adId(lt.content)) ? lt : ((ft && adId(ft.content)) ? ft : null);
    var ad = (src && adId(src.content)) || adId(touch.content) || (tok && tok.ad) || "";
    var camp = (src && adId(src.campaign)) || adId(touch.campaign) || (tok && tok.camp) || "";
    var fc = fbcParts();
    var clid = "", ts = 0;
    if (fc && Date.now() - fc.ts <= 7 * 864e5) { clid = fc.fbclid; ts = fc.ts; }
    else if (tok && tok.fbclid) { clid = tok.fbclid; ts = tok.ts; }
    else if (/^[A-Za-z0-9_.-]{8,500}$/.test(urlFbclid)) { clid = urlFbclid; ts = Date.now(); }
    if (!ts) {
      ts = (src && src.ts ? Date.parse(src.ts) || 0 : 0) ||
           (tok && tok.ts) ||
           (adId(touch.content) ? Date.now() : 0);
    }
    if (!ad && !clid) return "";
    if (!ts || Date.now() - ts > 7 * 864e5) return "";
    return [ad, camp, ts, clid].join("~");
  }
  function addDyad(url, token) {
    var h = url.indexOf("#"), hash = "";
    if (h !== -1) { hash = url.slice(h); url = url.slice(0, h); }
    if (!url) return url + hash;
    if (/[?&]dyad=/.test(url)) return url + hash;
    return url + (url.indexOf("?") === -1 ? "?" : "&") + "dyad=" + token + hash;
  }
  function stripDyad(search) {
    var s = search, prev;
    do { prev = s; s = s.replace(/([?&])dyad=[^&#]*&/, "$1"); } while (s !== prev);
    s = s.replace(/[?&]dyad=[^&#]*/, "");
    if (s.charAt(0) === "&") s = "?" + s.slice(1);
    return s;
  }
  if (IAB) {
    try {
      var tk0 = dyadToken();
      if (tk0)
        history.replaceState(history.state, "", addDyad(location.pathname + location.search, tk0) + location.hash);
      var wrapHist = function (k) {
        var orig = history[k];
        if (!orig) return;
        history[k] = function (st, ti, u) {
          try {
            /* URL objects are a common rewrite pattern: decorate their href.
               Hash-only URLs are skipped -- they keep the current query (and
               its dyad) natively, while "?dyad=...#x" would WIPE the page's
               query state. Absolute means a real scheme or a leading // ; a
               "//" later in the string (e.g. a return_url param value) does
               not make a relative URL absolute. */
            if (u !== null && typeof u === "object" && typeof u.href === "string") u = u.href;
            if (typeof u === "string" && u.length > 0 && u.charAt(0) !== "#") {
              var abs = /^[a-z][a-z0-9+.-]*:\/\//i.test(u) || u.indexOf("//") === 0;
              if (!abs || u.indexOf(location.origin + "/") === 0 || u === location.origin) {
                var tk = dyadToken();
                if (tk) u = addDyad(u, tk);
              }
            }
          } catch (e) {}
          return orig.call(this, st, ti, u);
        };
      };
      wrapHist("replaceState");
      wrapHist("pushState");
    } catch (e) {}
  } else if (qs.get("dyad") !== null && /[?&]dyad=/.test(location.search)) {
    /* Strip a consumed OR invalid token from the address bar (gated on the
       raw param, not on tok validity, so junk never lingers in shared URLs). */
    try {
      history.replaceState(history.state, "", location.pathname + stripDyad(location.search) + location.hash);
    } catch (e) {}
  }

  function attrs() {
    if (!consentOK()) return {};
    var ft = null, lt = null;
    try { ft = JSON.parse(getCookie(FT) || "null"); } catch (e) {}
    try { lt = JSON.parse(getCookie(LT) || "null"); } catch (e) {}
    ft = ft || touch; lt = lt || ft;
    var a = {
      _utm_source: ft.source,
      _utm_medium: ft.medium,
      _utm_campaign: ft.campaign,
      _utm_content: ft.content,
      _landing_url: ft.landing,
      _referrer: ft.referrer,
      _first_touch_ts: ft.ts,
      _visitor_id: vid,
      _last_source: lt.source,
      _last_medium: lt.medium,
      _last_content: lt.content
    };
    var fa = adId(ft.content), la = adId(lt.content);
    if (fa) a._ad_id = fa;
    if (la && la !== fa) a._last_ad_id = la;
    /* read live so a late pixel-set _fbp lands on a later flush */
    var fbp = getCookie("_fbp"), fbc = getCookie("_fbc");
    if (fbp) a._fbp = fbp;
    if (fbc) a._fbc = fbc;
    return a;
  }

  var lastSent = "";
  function flush() {
    if (!consentOK()) return Promise.resolve();
    var body = JSON.stringify({ attributes: attrs() });
    if (body === lastSent) return Promise.resolve();
    lastSent = body;
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: body,
      keepalive: true
    }).catch(function () { lastSent = ""; });
  }

  /* Micro events: once per visitor, same event id to fbq + collector */
  var memFlags = {};
  function fired(k) {
    if (memFlags[k]) return true;
    try {
      var f = JSON.parse(localStorage.getItem(FLAGS) || "{}");
      return !!(f && f[k]);
    } catch (e) { return false; }
  }
  function markFired(k) {
    if (!consentOK()) return ;
    memFlags[k] = 1;
    try {
      var f = {};
      try { f = JSON.parse(localStorage.getItem(FLAGS) || "{}") || {}; } catch (e2) {}
      f[k] = 1;
      localStorage.setItem(FLAGS, JSON.stringify(f));
    } catch (e) {}
  }
  function firstTouchAdId() {
    var ft = null;
    try { ft = JSON.parse(getCookie(FT) || "null"); } catch (e) {}
    return adId((ft || touch).content);
  }
  /* Server-side only. The collector maps event_name -> the Meta FP* custom event
     and sends it via CAPI. We deliberately do NOT also fire fbq() here: Meta
     counts the browser and server legs as separate events in Events Manager, and
     the browser leg is the lossier of the two (it races the navigation the click
     triggers), so one server leg is both simpler and more complete. */
  function fireMicro(name, dollars) {
    if (!consentOK()) return ;
    if (fired(name)) return;
    markFired(name);
    var id = uuid();
    try {
      fetch(COLLECT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          event_id: id,
          event_name: name,
          ad_id: firstTouchAdId() || null,
          session_id: vid,
          url: location.href,
          value: dollars,
          currency: "USD",
          consent_state: consentState(),
          privacy: window.DiyonaPrivacy.get(),
          fbp: getCookie("_fbp") || null,
          fbc: getCookie("_fbc") || null,
          ts: new Date().toISOString()
        }),
        keepalive: true
      }).catch(function () {});
    } catch (e) {}
  }
  function checkCart() {
    if (!consentOK()) return ;
    if (fired("second_item_added") && fired("high_value_cart")) return;
    try {
      fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
        if (!c) return;
        var dollars = (c.total_price || 0) / 100;
        if (c.item_count >= 2) fireMicro("second_item_added", dollars);
        if ((c.total_price || 0) >= 100000) fireMicro("high_value_cart", dollars);
      }).catch(function () {});
    } catch (e) {}
  }

  /* Diamond IN CART: a /cart/add.js carrying a `Diamond` (and `Certificate`)
     line-item property -- the complete-ring add on /pages/complete-ring, or the
     "Buy Loose" path on diamond-detail. NOTE this is the CART ADD, which sits
     several steps after the shopper actually picks a stone; the pick itself is
     fireDiamondSelected() below. Read the price back off the cart for value.
     Once per visitor, like the other micro events. */
  function bodyHasDiamond(init) {
    try {
      var b = init && init.body;
      if (typeof b !== "string") return false;
      var j = JSON.parse(b);
      var items = j.items ? j.items : (j.id ? [j] : []);
      for (var i = 0; i < items.length; i++) {
        var pr = items[i] && items[i].properties;
        if (pr && (pr.Diamond || pr.Certificate)) return true;
      }
    } catch (e) {}
    return false;
  }
  function fireDiamondInCart() {
    if (fired("diamond_in_cart")) return;
    try {
      fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
        var dollars = 0;
        if (c && c.items) {
          for (var i = 0; i < c.items.length; i++) {
            var it = c.items[i], pr = it.properties || {};
            if (pr.Diamond || pr.Certificate) {
              dollars = (it.final_line_price || it.final_price || it.price || 0) / 100;
              break;
            }
          }
        }
        fireMicro("diamond_in_cart", dollars);
      }).catch(function () { fireMicro("diamond_in_cart", 0); });
    } catch (e) { fireMicro("diamond_in_cart", 0); }
  }

  /* Generic once-per-visitor event valued at the current cart total. */
  function fireWithCartValue(name) {
    if (fired(name)) return;
    try {
      fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
        fireMicro(name, ((c && c.total_price) || 0) / 100);
      }).catch(function () { fireMicro(name, 0); });
    } catch (e) { fireMicro(name, 0); }
  }

  /* Setting selection: "Choose This Setting" (#sp-choose-btn) calls
     RingBuilder.saveSetting(), which writes the rb_setting cookie (JSON incl.
     the setting price) and navigates to the diamond step. Detect the cookie's
     presence -- fires on the next page load after a setting is chosen. */
  function fireSettingSelected() {
    if (fired("setting_selected")) return;
    var raw = getCookie("rb_setting");
    if (!raw) return;
    var price = 0;
    try { var s = JSON.parse(raw); price = Number(s && s.price) || 0; } catch (e) {}
    fireMicro("setting_selected", price);
  }

  /* Diamond selection: "Select This Diamond" (#dd-select-btn on /pages/diamond-detail)
     calls RingBuilder.saveDiamond(), which writes the rb_diamond cookie (JSON incl.
     the diamond price in dollars) then navigates to the complete-ring step. That
     button never touches the cart, so cookie presence is the only signal for the
     PICK -- mirrors fireSettingSelected(). Fires on the next page load after a
     diamond is chosen. Diamond-first shoppers fire this without a setting, by
     design: it counts stone picks, not builder completions. */
  function fireDiamondSelected() {
    if (fired("diamond_selected")) return;
    var raw = getCookie("rb_diamond");
    if (!raw) return;
    var price = 0;
    try { var d = JSON.parse(raw); price = Number(d && d.price) || 0; } catch (e) {}
    fireMicro("diamond_selected", price);
  }

  /* Initiate checkout: the storefront "Checkout" button (name="checkout") on the
     cart page and mobile cart CTA. Wallet / express buttons (Shop Pay, PayPal,
     Apple Pay, Google Pay) bypass this navigation and are NOT counted.
     v7: listen on WINDOW in the capture phase, never on document.
     optimistic-cart.js loads before this file and, since its swap v3
     (2026-09-18), stops EVERY checkout click at document capture
     (stopImmediatePropagation) and then submits the form itself via
     requestSubmit(). A document listener here therefore never ran, and
     FPInitiateCheckout read zero from 2026-09-18 to 2026-10-14. Window capture
     runs before any document listener, so the cart script cannot block it. */
  try {
    window.addEventListener("click", function (ev) {
      try {
        var t = ev.target;
        var el = t && t.closest ? t.closest('[name="checkout"], .cart__checkout, a[href*="/checkout"]') : null;
        if (el) fireWithCartValue("initiate_checkout");
      } catch (e) {}
    }, true);
  } catch (e) {}

  function isSignupForm(f) {
    try {
      if (!f || !f.querySelector) return false;
      /* Shopify newsletter + contact forms BOTH post to /contact with a
         contact[email] input; only form_type distinguishes them. */
      var ftEl = f.querySelector('input[name="form_type"]');
      var formType = ftEl ? ftEl.value : "";
      if (formType === "customer") return true;
      if (formType === "contact") return false;
      if (f.querySelector('input[type="email"]')) {
        var action = f.getAttribute("action") || "";
        var hint = (action + " " + String(f.className || "")).toLowerCase();
        if (/newsletter|klaviyo|subscribe/.test(hint)) return true;
      }
    } catch (e) {}
    return false;
  }
  try {
    document.addEventListener("submit", function (ev) {
      try {
        if (isSignupForm(ev.target)) fireMicro("email_signup", 0);
      } catch (e) {}
    }, true);
  } catch (e) {}

  window.Diyona = window.Diyona || {};
  window.Diyona.attribution = { attrs: attrs, flush: flush, visitorId: vid };

  fireSettingSelected();
  fireDiamondSelected();
  if (getCookie("cart")) { flush(); checkCart(); }

  /* Stamp new carts created after page load (AJAX add-to-cart), and re-check
     cart milestones on quantity changes too (/cart/change covers the drawer
     +/- path; checkCart fetches /cart.js which matches neither pattern, so
     no recursion). A /cart/add carrying a Diamond property also fires the
     diamond_added micro event. */
  try {
    var origFetch = window.fetch;
    window.fetch = function () {
      var p = origFetch.apply(this, arguments);
      try {
        var u = arguments[0];
        var url = (typeof u === "string") ? u : (u && u.url) || "";
        if (url.indexOf("/cart/add") !== -1 || url.indexOf("/cart/change") !== -1 || url.indexOf("/cart/update") !== -1) {
          var diamondAdd = url.indexOf("/cart/add") !== -1 && bodyHasDiamond(arguments[1]);
          p.then(function () { setTimeout(function () { flush(); checkCart(); fireSettingSelected(); fireDiamondSelected(); if (diamondAdd) fireDiamondInCart(); }, 300); });
        }
      } catch (e) {}
      return p;
    };
  } catch (e) {}

  /* Fallback: poll briefly for a cart cookie appearing (non-fetch ATC) */
  var polls = 0;
  var t = setInterval(function () {
    polls++;
    fireSettingSelected();
    fireDiamondSelected();
    if (getCookie("cart")) { flush(); checkCart(); clearInterval(t); }
    else if (polls > 30) clearInterval(t);
  }, 4000);
  });
})();
